import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import MDIGITAL_WCAG from "./MDIGITAL_WCAG";
import MDIGITAL_LOGGER from "./MDIGITAL_LOGGER";
import MDIGITAL_ANALYTICS from './MDIGITAL_ANALYTICS';

  var CURRENT_SHOWN_MODAL_INITIAL_STATE = {
    formId: null,
    targetModalId: '',
  };
  var rootWindow = window.top;
  var currentShownModal = {};

  function init() {
    initModalState();
    KAMPYLE_EVENT_DISPATCHER.subscribeMany({
      // modal open events
      neb_formShown: [onFormShown],
      neb_captureImageClicked: [refocusForm],
      MDigital_Capture_Cancelled: [refocusForm],
      neb_inviteReady: [onInviteReady, focusOnModal, announceInvitation, trapFocus],
      MDigital_noJsonModalShown: [onNoJsonModalShown, focusOnModal, trapFocus],
      // modal closed events
      neb_formClosed: [onFormClosed],
      neb_inviteAccepted: [releaseFocus, initModalState],
      neb_inviteDeclined: [releaseFocus, initModalState],
      MDigital_noJsonModalClosed: [releaseFocus, initModalState],
      ...KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.WCAG_REVIEW_FIXES) &&
      { neb_button_displayed:[focusOnFeedbackButton]},
    });
  }

  function initModalState() {
    Object.assign(currentShownModal, CURRENT_SHOWN_MODAL_INITIAL_STATE);
  }

  function onFormShown(eventName, payload) {
    if (KAMPYLE_UTILS.isModalFormType(payload.formId)) {
      setModalState({
        formId: payload.formId,
        targetModalId: KAMPYLE_DATA.getFormIframeId(payload.formId)
      });
      MDIGITAL_WCAG.focusOnModal();
      MDIGITAL_WCAG.trapFocus();
    }
  }

  function refocusForm(){
    var targetModal = document.getElementById(currentShownModal.targetModalId);
    if(targetModal && targetModal.contentWindow){
      targetModal.contentWindow.focus();
    }
  }

  function setModalState(newState) {
    Object.assign(currentShownModal, newState);
  }

  function focusOnModal() {
    var targetModal = document.getElementById(currentShownModal.targetModalId);
    if (targetModal && typeof targetModal.focus === 'function') {
      targetModal.focus();
    }
  }

  function announceInvitation() {
    // On Firefox with NVDA screen reader, the invitation isn't auto focused nor announced
    var targetModal = document.getElementById(currentShownModal.targetModalId);
    var browser = KAMPYLE_UTILS.getNestedPropertyValue(KAMPYLE_UTILS.getBrowser(), 'name');
    if (targetModal && browser === KAMPYLE_CONSTANT.BROWSERS.FIREFOX) {
      targetModal.setAttribute('aria-hidden','true');
      setTimeout(function () {
        targetModal.setAttribute('role', 'alert');
        targetModal.setAttribute('aria-hidden', 'false');
      }, 250);
    }
  }

  function trapFocus() {
      try {
          rootWindow.addEventListener(KAMPYLE_CONSTANT.BROWSER_EVENTS.FOCUS, focusOnModal);
      } catch (e) {
          handleRootWindowError(e)
      }
  }

  function onInviteReady(eventName, payload) {
    setModalState({
      targetModalId: KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.IFRAME_ID
    });
  }

  function onNoJsonModalShown(eventName, payload) {
    setModalState({
      targetModalId: KAMPYLE_CONSTANT.IFRAME_SETTINGS.OOPS.CONTAINER_ID_PREFIX + payload.formId,
    });
  }

  function onFormClosed(eventName, payload) {
    var formId = payload.formId;
    // in case where Embedded form on the same page was closed
    if (formId === currentShownModal.formId) {
      releaseFocus();
      initModalState();
    }
  }


  function releaseFocus() {
    try {
      rootWindow.removeEventListener(KAMPYLE_CONSTANT.BROWSER_EVENTS.FOCUS, focusOnModal);
    } catch (e) {
        handleRootWindowError(e)
    }
  }

  function handleRootWindowError(e) {
    if ({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isDigitalAnalyticsEnabled) {
      MDIGITAL_ANALYTICS.triggerDigitalAnalyticsEventDispatcherError({ errorMessage: e.message, errorStack: e.stack });
    }
    if(MDIGITAL_LOGGER.getLoggerStatus()){
      MDIGITAL_LOGGER.error(e);
    }
  }

  // for testing purpose only
  function getModalState() {
    return currentShownModal;
  }

  function focusOnFeedbackButton(eventName,data){
    if(data.formClosed){
      var feedbackButton = document.getElementById('nebula_div_btn');
      if (feedbackButton && typeof feedbackButton.focus === 'function') {
        feedbackButton.focus();
      }
    }
  }

  export default {
    init: init,
    // for testing
    initModalState: initModalState,
    onFormShown: onFormShown,
    getModalState: getModalState,
    setModalState: setModalState,
    focusOnModal: focusOnModal,
    trapFocus: trapFocus,
    refocusForm: refocusForm,
    announceInvitation: announceInvitation,
    CURRENT_SHOWN_MODAL_INITIAL_STATE: CURRENT_SHOWN_MODAL_INITIAL_STATE
  }
